'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _index = require('@/config/index');

var _axios3 = require('@/config/interceptors/axios');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var axiosInstance = _axios2.default.create(_index.AXIOS_DEFAULT_CONFIG);
axiosInstance.interceptors.request.use(_axios3.reqSucCallback, _axios3.reqFailCallback);
axiosInstance.interceptors.response.use(_axios3.resSucCallback, _axios3.resFailCallback);
exports.default = axiosInstance;